import { host, port } from "../../config/config";

export const setupWebsocket = () =>
  new Promise(resolve => {
    let path = '';
    // si un port est renseigné: mode DEV
    const { location: { hostname, port: portBrowser } } = document;
    if (portBrowser) {
      path = host;
    } else {
      path = hostname;
    }
    const webSocket = new WebSocket(`ws://${path}:${port}`);

    const receive = onMessageCb => {
      webSocket.onmessage = event => {
        console.log(event);
        onMessageCb(JSON.parse(event.data));
      };
    };

    const send = (payload) => {
      webSocket.send(JSON.stringify(payload));
    };

    webSocket.onopen = () => {
      resolve({ send, receive });
    };
  });
